module.exports = __webpack_public_path__ + "static/bevog_full-0eecf8e064187d6f6aba2950eb6f36dc.mp4";